import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import GlobalContext from '~/context/vdp/GlobalContext';

type OwnProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export default function BelowFoldViewHandler({ children, ...props }: OwnProps) {
  const { setLazyLoadEnabled } = useContext(GlobalContext);
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  useEffect(() => {
    if (inView) {
      setLazyLoadEnabled(false);
    }
  }, [inView, setLazyLoadEnabled]);

  return (
    <div ref={ref} {...props}>
      {children}
    </div>
  );
}
